import type { GridApi } from '@mint-lib/ag-grid/community';
import type { MediaPlan } from '@mint-sdk/api-media-plan';
import { atom, useAtom } from 'jotai';

export const gridApiAtom = atom<GridApi<MediaPlan.MediaData> | null>(null);

export const usePlanningGridApi = () => {
  return useAtom(gridApiAtom);
};
